import { render, staticRenderFns } from "./privacy-policy-container.vue?vue&type=template&id=6e9fde1b&scoped=true&lang=pug"
import script from "./privacy-policy-container.js?vue&type=script&lang=js&external"
export * from "./privacy-policy-container.js?vue&type=script&lang=js&external"
import style0 from "./privacy-policy-container.vue?vue&type=style&index=0&id=6e9fde1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9fde1b",
  null
  
)

export default component.exports